module.exports = __webpack_public_path__ + "static/media/Face_cut_2.e8a46648.png";